/* TinyTots compact size selector and direct cart add, for Kalles product tiles. */
(function(){
"use strict";
if(window.__ttCompactCart)return;window.__ttCompactCart=true;
var cache=new Map(),busy=false,popup,oldFocus,cardPrice=null;
function base(){return window.Shopify&&Shopify.routes&&Shopify.routes.root||"/"}
function getProduct(h){
 if(cache.has(h))return cache.get(h);
 var p=fetch(base()+"products/"+encodeURIComponent(h)+".js",{credentials:"same-origin"}).then(function(r){if(!r.ok)throw Error("Product unavailable");return r.json()}).catch(function(e){cache.delete(h);throw e});cache.set(h,p);return p;
}
function node(tag,cls,text){var n=document.createElement(tag);n.className=cls||"";if(text!==undefined)n.textContent=text;return n}
function price(n){return "Rs. "+(Number(n||0)/100).toLocaleString("en-PK",{maximumFractionDigits:0})}
var bands={"0-3m":[0,3],"3-12m":[3,12],"1-2y":[12,24],"2-4y":[24,48],"4-6y":[48,72],"6-8y":[72,96],"8-14y":[96,168]};
function size(s){
 s=String(s||"").toLowerCase().trim().replace(/[–—−]/g,"-").replace(/\s+/g,"").replace(/months?|mos?/g,"m").replace(/years?|yrs?/g,"y");
 if(["nb","newborn","new-born"].includes(s))return [0,3];
 var m=s.match(/^(\d{1,2})-(\d{1,2})([my])$/);if(m){var mult=m[3]==="y"?12:1;return [+m[1]*mult,+m[2]*mult]}
 m=s.match(/^(\d{1,2})([my])$/);if(m){var n=+m[1]*(m[2]==="y"?12:1);return [n,n+1]}
 return null;
}
function inBand(v,k){if(!k||!bands[k])return true;return [v.option1,v.option2,v.option3].some(function(s){var r=size(s);return r&&r[0]<bands[k][1]&&r[1]>bands[k][0]})}
function getImage(p,v){var img=v&&v.featured_image||p.featured_image;return typeof img==="string"?img:img&&img.src||""}
function priceDisplay(variant){
 var wrap=document.createElement("span");
 if(cardPrice&&cardPrice.original&&cardPrice.discounted){
   var del=document.createElement("del"),ins=document.createElement("ins");
   var unit=Number(variant.price||0)/100;
   var prev=cardPrice.originalNum>0?cardPrice.discountedNum/cardPrice.originalNum:1;
   if(cardPrice.variantOnly)prev=1;
   del.textContent=price(variant.price);
   ins.textContent=price(Math.round(Number(variant.price||0)*prev));
   wrap.append(del," ",ins);
 }else{
   wrap.textContent=price(variant.price);
 }
 return wrap;
}
function captureCardPrice(button){
 var card=button.closest(".t4s-product,.t4s-product-wrapper,.t4s-pr-grid");
 var priceEl=card&&card.querySelector(".t4s-product-price");
 if(!priceEl)return null;
 var original=priceEl.querySelector("del"),discounted=priceEl.querySelector("ins");
 if(!original||!discounted)return null;
 function numeric(n){var x=n&&n.textContent.match(/\d[\d,]*(?:\.\d+)?/);return x?Number(x[0].replace(/,/g,"")):0}
 var o=numeric(original),d=numeric(discounted);return o>0&&d>0&&d<o?{original:original.textContent,discounted:discounted.textContent,originalNum:o,discountedNum:d}:null;
}
function close(){if(busy||!popup||popup.hidden)return;popup.hidden=true;document.body.classList.remove("tt-quickadd-open");if(oldFocus&&oldFocus.isConnected)oldFocus.focus()}
function ensure(){
 if(popup)return popup;
 popup=node("div","tt-fastadd");popup.hidden=true;
 popup.innerHTML='<button type="button" class="tt-fastadd__scrim" aria-label="Close"></button><section class="tt-fastadd__panel" role="dialog" aria-modal="true" aria-labelledby="tt-fastadd-title"><button class="tt-fastadd__close" type="button" aria-label="Close">×</button><div class="tt-fastadd__product"><img class="tt-fastadd__image" alt=""><div><h2 id="tt-fastadd-title"></h2><p class="tt-fastadd__price"></p></div></div><div class="tt-fastadd__options"></div><p class="tt-fastadd__message" role="status" aria-live="polite"></p><a class="tt-fastadd__details" href="#">View full details →</a></section>';
 document.body.append(popup);
 popup.querySelector(".tt-fastadd__close").onclick=close;popup.querySelector(".tt-fastadd__scrim").onclick=close;
 document.addEventListener("keydown",function(e){if(!popup.hidden&&e.key==="Escape"){e.preventDefault();close()}});
 return popup;
}
async function refresh(){
 try{
  var preview=new URLSearchParams(location.search).get("preview_theme_id");
  var url=base()+"cart?section_id=mini_cart"+(preview?"&preview_theme_id="+encodeURIComponent(preview):"");
  var res=await fetch(url,{credentials:"same-origin",cache:"no-store"});
  if(!res.ok)return;
  var doc=new DOMParser().parseFromString(await res.text(),"text/html");
  var src=doc.querySelector("#t4s-mini_cart")||doc.body,dst=document.querySelector("#t4s-mini_cart");
  if(!dst)return;
  ["[data-cart-items]","[data-cart-prices]","[data-cart-discounts]"].forEach(function(sel){
   var a=dst.querySelector(sel),b=src.querySelector(sel);if(a&&b)a.replaceWith(b.cloneNode(true));
  });
 }catch(e){}
}
async function add(variant,btn){
 if(busy)return;busy=true;if(btn)btn.disabled=true;
 var msg=popup&&!popup.hidden?popup.querySelector(".tt-fastadd__message"):null;if(msg)msg.textContent="Adding to cart…";
 try{
  var res=await fetch(base()+"cart/add.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:Number(variant.id),quantity:1}]})});
  var data=await res.json();if(!res.ok)throw Error(data.description||data.message||"Could not add item");
  await refresh();
  try{var cart=await fetch(base()+"cart.js",{credentials:"same-origin",cache:"no-store"}).then(function(r){return r.json()});document.documentElement.classList.toggle("t4s-cart-count-0",cart.item_count===0);document.querySelector("#t4s-mini_cart")?.setAttribute("data-ccount",String(cart.item_count));document.querySelectorAll(".t4s-cart-count,[data-cart-count]").forEach(function(x){if(!x.children.length)x.textContent=cart.item_count})}catch(e){}
  if(popup&&!popup.hidden){popup.hidden=true;document.body.classList.remove("tt-quickadd-open")}
  var status=document.getElementById("tt-cart-toast");if(!status){status=document.createElement("div");status.id="tt-cart-toast";status.setAttribute("role","status");status.className="tt-cart-toast";document.body.append(status)}
  status.textContent="Added to cart";status.classList.add("tt-cart-toast--show");clearTimeout(window.__ttToastTimer);window.__ttToastTimer=setTimeout(function(){status.classList.remove("tt-cart-toast--show")},2400);
  document.dispatchEvent(new CustomEvent("cart:changed",{bubbles:true}));
  if(oldFocus&&oldFocus.isConnected)oldFocus.focus();
 }catch(e){if(msg)msg.textContent=e.message||"Could not add item";else if(btn)btn.title=e.message||"Could not add item"}
 finally{busy=false;if(btn)btn.disabled=false}
}
function open(p,list,trigger,colour){
 var box=ensure();oldFocus=trigger;box.hidden=false;document.body.classList.add("tt-quickadd-open");
 box.querySelector("h2").textContent=p.title;box.querySelector(".tt-fastadd__details").href="/products/"+encodeURIComponent(p.handle);
 var image=box.querySelector(".tt-fastadd__image"),desc=box.querySelector(".tt-fastadd__price");
 var opts=box.querySelector(".tt-fastadd__options");opts.replaceChildren();box.querySelector(".tt-fastadd__message").textContent="";
 var options=(p.options||[]).map(function(x){return typeof x==="string"?x:x.name||""});
 var ci=options.findIndex(function(x){return /colou?r|shade|pattern/i.test(x)});
 var si=options.findIndex(function(x){return /size|age|months?/i.test(x)});
 if(si<0)si=[0,1,2].find(function(i){return list.some(function(v){return !!size([v.option1,v.option2,v.option3][i])})});
 if(si===undefined)si=-1;
 var colours=ci<0?[]:[...new Set(list.map(function(v){return String([v.option1,v.option2,v.option3][ci]||"")}))];
 var picked=colours.includes(colour)?colour:colours[0];
 var label=node("p","tt-fastadd__label",si>=0?"CHOOSE SIZE":"AVAILABLE OPTIONS");
 var sizes=node("div","tt-fastadd__chips");
 function render(){
  sizes.replaceChildren();var variants=list.filter(function(v){return colours.length<2||String([v.option1,v.option2,v.option3][ci]||"")===picked});
  var seen=new Set();
  variants.forEach(function(v){
   var n=si>=0?String([v.option1,v.option2,v.option3][si]||""):v.title||"Add to cart";
   if(seen.has(n))return;seen.add(n);
   var b=node("button","tt-fastadd__chip",n);b.type="button";b.onclick=function(){add(v,b)};sizes.append(b);
  });
  if(variants.length){desc.replaceChildren(priceDisplay(variants[0]));var src=getImage(p,variants[0]);if(src){image.src=src;image.hidden=false}else image.hidden=true}
 }
 if(colours.length>1){
  opts.append(node("p","tt-fastadd__label","CHOOSE COLOUR"));
  var cRow=node("div","tt-fastadd__chips");opts.append(cRow);
  colours.forEach(function(c){var b=node("button","tt-fastadd__chip",c);b.type="button";b.setAttribute("aria-pressed",String(picked===c));b.onclick=function(){picked=c;cRow.querySelectorAll("button").forEach(function(x){x.setAttribute("aria-pressed",String(x===b))});render()};cRow.append(b)})
 }
 opts.append(label,sizes);render();box.querySelector(".tt-fastadd__close").focus();
}
document.addEventListener("click",async function(e){
 var b=e.target.closest&&e.target.closest("[data-tt-quick-add],.t4s-pr-grid .t4s-product-inner a[data-action-quickshop],.t4s-pr-grid .t4s-product-inner a[data-action-atc]");
 if(!b||b.closest("#t4s-mini_cart"))return;
 var card=b.closest(".t4s-pr-grid"),handle=b.dataset.ttQuickAdd||"";
 if(!handle&&card){try{handle=JSON.parse(card.dataset.productOptions||"{}").handle||""}catch(ignore){}}
 if(!handle&&b.href){var found=new URL(b.href,location.href).pathname.match(/\/products\/([^/]+)/);if(found)handle=decodeURIComponent(found[1])}
 if(!handle)return;
 e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
 if(busy)return;
 oldFocus=b;cardPrice=captureCardPrice(b);
 try{
  var p=await getProduct(handle);
  if(p.requires_selling_plan){location.href="/products/"+encodeURIComponent(handle);return}
  var variants=(p.variants||[]).filter(function(v){return v.available&&inBand(v,b.dataset.ttAgeGroup)});
  var chosenId=b.dataset.ttDirectAgeVariant;
  if(chosenId&&card&&card.classList.contains("tt-age-card")){
    var chosen=variants.find(function(v){return String(v.id)===chosenId});
    if(chosen)await add(chosen,b);
    else b.title="This size is no longer available";
    return;
  }
  var colour=b.dataset.ttColorValue||"",option=(p.options||[]).findIndex(function(x){return /colou?r|shade|pattern/i.test(typeof x==="string"?x:x.name||"")});
  if(colour&&option>=0)variants=variants.filter(function(v){return String([v.option1,v.option2,v.option3][option]||"")===colour});
  if(variants.length===1)await add(variants[0],b);
  else if(variants.length>1)open(p,variants,b,colour);
  else b.title="No available size for this selection";
 }catch(error){b.title=error.message||"Unable to load sizes"}
},true);
})();